"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ModalMain =
/*#__PURE__*/
function (_Component) {
  _inherits(ModalMain, _Component);

  function ModalMain() {
    _classCallCheck(this, ModalMain);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModalMain).apply(this, arguments));
  }

  _createClass(ModalMain, [{
    key: "getModal",
    value: function getModal() {
      return this.props.modal ? "modal full-width single-row modal-block" : "modal full-width single-row modal-none";
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement("div", {
        className: this.getModal()
      }, _react.default.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, _react.default.createElement("div", {
        className: "modal-content"
      }, _react.default.createElement("div", {
        className: "modal-header"
      }, _react.default.createElement("strong", {
        className: "modal-title"
      }, this.props.title), _react.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        onClick: function onClick() {
          return _this.props.hideMethod();
        }
      }, _react.default.createElement("span", {
        "aria-hidden": "true"
      }, _react.default.createElement("i", {
        className: "fa fa-times",
        "aria-hidden": "true"
      })))), _react.default.createElement("div", {
        className: "modal-body double-modal"
      }, this.props.children), _react.default.createElement("div", {
        className: "modal-footer"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button-large button-transparent",
        onClick: function onClick() {
          return _this.props.secondaryMethod();
        }
      }, this.props.btnTitle2), _react.default.createElement("button", {
        type: "button",
        className: "button-large button-blue",
        onClick: function onClick() {
          return _this.props.primaryMethod();
        }
      }, this.props.btnTitle1)))));
    }
  }]);

  return ModalMain;
}(_react.Component);

var _default = ModalMain;
exports.default = _default;